import { IoMdLink } from 'react-icons/io'

interface CompanyHeaderProps {
  companyName: string
  logoUrl?: string
  domain?: string
  isUserCreated?: boolean
}

export function CompanyHeader({
  companyName,
  logoUrl,
  domain,
  isUserCreated,
}: CompanyHeaderProps) {
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col items-center gap-2.5 self-stretch mt-3">
        <div className="flex flex-col items-center gap-2.5">
          {/* Company Logo */}
          {!isUserCreated && (
            <>
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={`${companyName} logo`}
                  className="w-12 h-12 rounded-full mr-1 object-cover object-center"
                />
              ) : (
                <div className="w-12 h-12 min-w-12 min-h-12 rounded-full bg-neutral-300" />
              )}
            </>
          )}

          {/* Company Name */}
          <div className="font-semibold text-3xl text-center text-gray-900 leading-tight">
            {companyName}
          </div>
        </div>

        {/* Domain Badge */}
        {domain && (
          <div className="flex items-center gap-3">
            <a
              href={`https://${domain}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 px-2 py-1 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition-colors"
            >
              <IoMdLink className="w-4 h-4 text-green-700" />
              <span className="text-xs font-medium text-green-700 text-center">
                {domain}
              </span>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
